// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as $$String from "rescript/lib/es6/string.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Js_json from "rescript/lib/es6/js_json.js";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Link$LiveRoom from "../../Link.bs.js";
import * as I18next$LiveRoom from "../../bindings/I18next.bs.js";
import * as LotCard$LiveRoom from "../../components/LotCard.bs.js";
import * as JsxPPXReactSupport from "rescript/lib/es6/jsxPPXReactSupport.js";
import * as ClockStore$LiveRoom from "../../stores/ClockStore.bs.js";
import * as PropSpread$LiveRoom from "../../components/PropSpread.bs.js";
import * as Webapi__Dom__Element from "rescript-webapi/src/Webapi/Dom/Webapi__Dom__Element.bs.js";
import * as Utils_Shared$LiveRoom from "../../Utils/Utils_Shared.bs.js";
import * as Utils_Auction$LiveRoom from "../../Utils/Utils_Auction.bs.js";
import * as SterlingTokens$LiveRoom from "../../bindings/SterlingTokens.bs.js";
import * as StyleConstants$LiveRoom from "../../styles/StyleConstants.bs.js";
import * as ClientapiQueries$LiveRoom from "../../ClientapiQueries.bs.js";
import * as SterlingTypography$LiveRoom from "../../bindings/SterlingTypography.bs.js";
import * as AlternativeCurrency$LiveRoom from "../../stores/AlternativeCurrency.bs.js";

function LotCardList$ParcelHeader(props) {
  var lotCount = props.lotCount;
  var match = I18next$LiveRoom.useTranslation(undefined);
  return React.createElement("div", {
              className: Curry._1(Css.style, {
                    hd: Css.height(Css.px(32)),
                    tl: {
                      hd: Css.padding4(Css.px(4), Css.px(16), Css.px(4), Css.px(16)),
                      tl: {
                        hd: Css.backgroundColor(Css.hex("F2E9F4")),
                        tl: {
                          hd: Css.display("flex"),
                          tl: {
                            hd: Css.alignItems("center"),
                            tl: /* [] */0
                          }
                        }
                      }
                    }
                  })
            }, React.createElement(SterlingTypography$LiveRoom.Caps12Medium.make, {
                  children: props.parcelName
                }), React.createElement(PropSpread$LiveRoom.make, {
                  data: {
                    hd: {
                      TAG: /* TestId */1,
                      _0: "parcelHeaderCount"
                    },
                    tl: /* [] */0
                  },
                  children: React.createElement(SterlingTypography$LiveRoom.Paragraph12Regular.make, {
                        className: Curry._1(Css.style, {
                              hd: Css.marginLeft(Css.px(8)),
                              tl: {
                                hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey80_nohashtag)),
                                tl: /* [] */0
                              }
                            }),
                        children: lotCount === 1 ? Curry._1(match.t, "ParcelHeaderCountSingular") : Curry._2(match.t2, "ParcelHeaderCount", {
                                lotCount: String(lotCount)
                              })
                      })
                }));
}

var ParcelHeader = {
  parcelHeaderHeight: 32,
  make: LotCardList$ParcelHeader
};

function LotCardList$LotCards(props) {
  var toggleMobileLotListClick = props.toggleMobileLotListClick;
  var me = props.me;
  var onClick = props.onClick;
  var selectedLotId = props.selectedLotId;
  var showLotCreators = props.showLotCreators;
  var scrollView = props.scrollView;
  var match = Belt_Array.reduce(props.lotCards, [
        [],
        {}
      ], (function (param, lotCard) {
          var parcels = param[1];
          var lots = param[0];
          var match = lotCard.parcel;
          if (match === undefined) {
            return [
                    Belt_Array.concat(lots, [[
                            lotCard,
                            undefined
                          ]]),
                    parcels
                  ];
          }
          var parcelName = match.parcelName;
          var parcelId = match.parcelId;
          var match$1 = Js_dict.get(parcels, parcelId);
          if (match$1 !== undefined) {
            parcels[parcelId] = [
              parcelName,
              Belt_Array.concat(match$1[1], [lotCard])
            ];
            return [
                    lots,
                    parcels
                  ];
          } else {
            parcels[parcelId] = [
              parcelName,
              []
            ];
            return [
                    Belt_Array.concat(lots, [[
                            lotCard,
                            parcelId
                          ]]),
                    parcels
                  ];
          }
        }));
  var parcels = match[1];
  var LotCardList$LotCards$1 = function (props) {
    var lotCard = props.lotCard;
    return JsxPPXReactSupport.createElementWithKey("LotCard-" + lotCard.id + "", LotCard$LiveRoom.make, {
                lotCard: lotCard,
                showLotCreators: showLotCreators,
                selectedLotId: selectedLotId,
                onClick: onClick,
                lotCardHeight: props.lotCardHeight,
                me: me,
                toggleMobileLotListClick: toggleMobileLotListClick,
                firstInParcel: props.firstInParcel,
                lastInParcel: props.lastInParcel
              });
  };
  var alternativeCurrency = Curry._1(AlternativeCurrency$LiveRoom.Context.use, undefined);
  var lotCardHeight = Belt_Option.isSome(alternativeCurrency) ? LotCard$LiveRoom.lotCardHeightWithCurrency : LotCard$LiveRoom.defaultLotCardHeight;
  var lotInView = function (offset) {
    if (offset >= scrollView[0]) {
      return offset <= scrollView[1];
    } else {
      return false;
    }
  };
  return Belt_Array.reduce(match[0], [
                [],
                0
              ], (function (param, param$1) {
                  var maybeParcel = param$1[1];
                  var lotCard = param$1[0];
                  var offset = param[1];
                  var allLots = param[0];
                  if (maybeParcel === undefined) {
                    return [
                            Belt_Array.concat(allLots, [lotInView(offset) ? React.createElement(LotCardList$LotCards$1, {
                                          lotCard: lotCard,
                                          lotCardHeight: lotCardHeight
                                        }) : React.createElement(LotCard$LiveRoom.Placeholder.make, {
                                          lotCard: lotCard,
                                          lotCardHeight: lotCardHeight
                                        })]),
                            offset + lotCardHeight | 0
                          ];
                  }
                  var match = Js_dict.get(parcels, maybeParcel);
                  if (match === undefined) {
                    return [
                            allLots,
                            offset
                          ];
                  }
                  var parcelLots = match[1];
                  return [
                          Belt_Array.concat(allLots, Belt_Array.concat([
                                    JsxPPXReactSupport.createElementWithKey("Parcel-" + maybeParcel + "", LotCardList$ParcelHeader, {
                                          parcelName: match[0],
                                          lotCount: parcelLots.length + 1 | 0
                                        }),
                                    lotInView(offset + 32 | 0) ? React.createElement(LotCardList$LotCards$1, {
                                            lotCard: lotCard,
                                            lotCardHeight: lotCardHeight,
                                            firstInParcel: true
                                          }) : React.createElement(LotCard$LiveRoom.Placeholder.make, {
                                            lotCard: lotCard,
                                            lotCardHeight: lotCardHeight
                                          })
                                  ], Belt_Array.mapWithIndex(parcelLots, (function (index, lotCard) {
                                          if (lotInView(((offset + 32 | 0) + lotCardHeight | 0) + Math.imul(lotCardHeight, index) | 0)) {
                                            return React.createElement(LotCardList$LotCards$1, {
                                                        lotCard: lotCard,
                                                        lotCardHeight: lotCardHeight,
                                                        lastInParcel: index === (parcelLots.length - 1 | 0)
                                                      });
                                          } else {
                                            return React.createElement(LotCard$LiveRoom.Placeholder.make, {
                                                        lotCard: lotCard,
                                                        lotCardHeight: lotCardHeight
                                                      });
                                          }
                                        })))),
                          (offset + 32 | 0) + Math.imul(lotCardHeight, parcelLots.length + 1 | 0) | 0
                        ];
                }))[0];
}

var LotCards = {
  make: LotCardList$LotCards
};

function LotCardList$NextSessionCard(props) {
  var auctionUrl = props.auctionUrl;
  var lotRange = props.lotRange;
  var sessionTitle = props.sessionTitle;
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t2 = match.t2;
  var t = match.t;
  var heading = sessionTitle !== undefined ? sessionTitle : Curry._2(t2, "Common_sessionNumber", {
          sessionNumber: props.sessionNumber
        });
  var sessionCountdown = Utils_Shared$LiveRoom.Timer.calculateDiff(ClockStore$LiveRoom.getServerTime(undefined), Utils_Shared$LiveRoom.Timer.stringToEpochTime(Belt_Option.getWithDefault(Js_json.decodeString(props.scheduledOpeningDate), "")));
  var tmp;
  if (typeof sessionCountdown === "number") {
    tmp = null;
  } else {
    switch (sessionCountdown.TAG | 0) {
      case /* LessThen24hours */0 :
          var match$1 = sessionCountdown._0;
          tmp = React.createElement(SterlingTypography$LiveRoom.Label14Medium.make, {
                children: "" + String(match$1.hour | 0) + "h " + String(match$1.min | 0) + "m"
              });
          break;
      case /* DaysUntil */1 :
          tmp = React.createElement(SterlingTypography$LiveRoom.Label14Medium.make, {
                children: "" + String(sessionCountdown._0) + "d"
              });
          break;
      case /* TimeUntilReached */2 :
          var match$2 = sessionCountdown._0;
          tmp = React.createElement(SterlingTypography$LiveRoom.Label14Medium.make, {
                children: "" + String(match$2.day) + "d " + String(match$2.hour | 0) + "h " + String(match$2.min | 0) + "m"
              });
          break;
      
    }
  }
  return React.createElement("div", {
              className: Curry._1(Css.style, {
                    hd: Css.height(Css.px(100)),
                    tl: {
                      hd: Css.display("flex"),
                      tl: {
                        hd: Css.flexDirection("column"),
                        tl: {
                          hd: Css.justifyContent("spaceBetween"),
                          tl: {
                            hd: Css.padding2("zero", Css.px(16)),
                            tl: {
                              hd: Css.backgroundColor(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey10_nohashtag)),
                              tl: {
                                hd: StyleConstants$LiveRoom.defaultBorder("right", undefined, undefined),
                                tl: {
                                  hd: StyleConstants$LiveRoom.defaultBorder("top", undefined, undefined),
                                  tl: /* [] */0
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  })
            }, React.createElement("div", undefined, React.createElement(SterlingTypography$LiveRoom.Label14Medium.make, {
                      className: Curry._1(Css.style, {
                            hd: Css.paddingTop(Css.px(14)),
                            tl: /* [] */0
                          }),
                      children: heading
                    }), lotRange !== undefined ? React.createElement("div", {
                        className: Curry._1(Css.style, {
                              hd: Css.display("flex"),
                              tl: {
                                hd: Css.flexDirection("row"),
                                tl: {
                                  hd: Css.gap(Css.px(4)),
                                  tl: /* [] */0
                                }
                              }
                            })
                      }, React.createElement(PropSpread$LiveRoom.make, {
                            data: {
                              hd: {
                                TAG: /* TestId */1,
                                _0: "seeLotsNextSession"
                              },
                              tl: /* [] */0
                            },
                            children: React.createElement(SterlingTypography$LiveRoom.Paragraph14Regular.make, {
                                  children: Curry._2(t2, "SeeLotsNextSessionRange", {
                                        fromLotNr: lotRange.fromLotNr,
                                        toLotNr: lotRange.toLotNr
                                      })
                                })
                          }), React.createElement(Link$LiveRoom.AuctionDetailPage.make, {
                            auctionUrl: auctionUrl,
                            children: React.createElement(PropSpread$LiveRoom.make, {
                                  data: {
                                    hd: {
                                      TAG: /* TestId */1,
                                      _0: "navigateToNextSession"
                                    },
                                    tl: /* [] */0
                                  },
                                  children: React.createElement(SterlingTypography$LiveRoom.Paragraph14Regular.make, {
                                        children: Curry._1(t, "NavigateToNextSession")
                                      })
                                }),
                            inNewTab: true,
                            className: Curry._1(Css.style, {
                                  hd: Css.textDecoration("none"),
                                  tl: /* [] */0
                                })
                          })) : React.createElement(Link$LiveRoom.AuctionDetailPage.make, {
                        auctionUrl: auctionUrl,
                        children: React.createElement(PropSpread$LiveRoom.make, {
                              data: {
                                hd: {
                                  TAG: /* TestId */1,
                                  _0: "seeLotsNextSessionLink"
                                },
                                tl: /* [] */0
                              },
                              children: React.createElement(SterlingTypography$LiveRoom.Paragraph14Regular.make, {
                                    children: Curry._1(t, "SeeLotsNextSession")
                                  })
                            }),
                        inNewTab: true,
                        className: Curry._1(Css.style, {
                              hd: Css.textDecoration("none"),
                              tl: /* [] */0
                            })
                      })), React.createElement("div", {
                  className: Curry._1(Css.style, {
                        hd: Css.display("flex"),
                        tl: {
                          hd: Css.justifyContent("spaceBetween"),
                          tl: {
                            hd: Css.paddingBottom(Css.px(4)),
                            tl: /* [] */0
                          }
                        }
                      })
                }, React.createElement(SterlingTypography$LiveRoom.Label14Medium.make, {
                      children: typeof sessionCountdown === "number" ? Curry._1(t, "StartsShortly") : "" + Curry._1(t, "StartingIn") + ":"
                    }), tmp));
}

var NextSessionCard = {
  make: LotCardList$NextSessionCard
};

function LotCardList(props) {
  var fragment = props.fragment;
  var sessions = fragment.sessions;
  var useCreatorSplit = fragment.useCreatorSplit;
  var toggleMobileLotListClick = props.toggleMobileLotListClick;
  var me = props.me;
  var selectLot = props.selectLot;
  var selectedLotId = props.selectedLotId;
  var alternativeCurrency = Curry._1(AlternativeCurrency$LiveRoom.Context.use, undefined);
  var match = React.useState(function () {
        return [
                0,
                5000
              ];
      });
  var setScrollView = match[1];
  var scrollView = match[0];
  var listRef = React.useRef(null);
  var resetScrollPosition = React.useCallback((function (param) {
          Belt_Option.forEach(Caml_option.nullable_to_opt(listRef.current), (function (listRef) {
                  var nextLot = listRef.querySelector("." + LotCard$LiveRoom.liveLotCardClassName + " + li");
                  Belt_Option.forEach((nextLot == null) ? undefined : Caml_option.some(nextLot), (function (nextLot) {
                          nextLot.scrollIntoView({
                                behavior: "smooth",
                                block: "start"
                              });
                        }));
                }));
        }), []);
  React.useEffect((function () {
          Curry._1(resetScrollPosition, undefined);
        }), [alternativeCurrency]);
  var scrollListener = React.useCallback((function (listRef) {
          return function (_event) {
            var scrollTop = listRef.scrollTop | 0;
            var listHeight = listRef.clientHeight;
            var start = scrollTop - 350 | 0;
            var end = (scrollTop + listHeight | 0) + 350 | 0;
            return Curry._1(setScrollView, (function (param) {
                          return [
                                  start,
                                  end
                                ];
                        }));
          };
        }), []);
  React.useEffect((function () {
          return Belt_Option.map(Caml_option.nullable_to_opt(listRef.current), (function (listRef) {
                        var listener = Curry._1(scrollListener, listRef);
                        listRef.addEventListener("scroll", listener);
                        return function (param) {
                          listRef.removeEventListener("scroll", listener);
                        };
                      }));
        }), []);
  var arrowListener = React.useCallback((function (listRef) {
          return function ($$event) {
            var keyCode = $$String.lowercase_ascii($$event.code);
            var lotCardElements = Array.prototype.slice.call(listRef.children);
            var numberOfLots = lotCardElements.length;
            if (!(keyCode === "arrowup" || keyCode === "arrowdown")) {
              return ;
            }
            var focusIndex = Belt_Option.getWithDefault(Belt_Array.getIndexBy(lotCardElements, (function (lot) {
                        var lotButton = lot.firstElementChild;
                        var lotButton$1 = (lotButton == null) ? undefined : Caml_option.some(lotButton);
                        var hasTabIndex = Caml_obj.equal(Belt_Option.flatMap(lotButton$1, (function (element) {
                                    return Caml_option.nullable_to_opt(element.getAttribute("tabIndex"));
                                  })), "0");
                        if (hasTabIndex) {
                          Belt_Option.forEach(lotButton$1, (function (element) {
                                  element.setAttribute("tabIndex", "-1");
                                }));
                        }
                        return hasTabIndex;
                      })), 0);
            var nextIndex = 0;
            switch (keyCode) {
              case "arrowdown" :
                  if ((focusIndex + 1 | 0) < numberOfLots) {
                    nextIndex = focusIndex + 1 | 0;
                  }
                  break;
              case "arrowup" :
                  nextIndex = (focusIndex - 1 | 0) < 0 ? numberOfLots - 1 | 0 : focusIndex - 1 | 0;
                  break;
              default:
                
            }
            var nextFocus = Belt_Array.get(lotCardElements, nextIndex);
            return Belt_Option.forEach(nextFocus, (function (nextFocus) {
                          Belt_Option.forEach(Belt_Option.flatMap(Caml_option.nullable_to_opt(nextFocus.firstElementChild), Webapi__Dom__Element.asHtmlElement), (function (nextFocusButton) {
                                  nextFocusButton.setAttribute("tabIndex", "0");
                                  nextFocusButton.focus();
                                }));
                        }));
          };
        }), []);
  React.useEffect((function () {
          return Belt_Option.map(Caml_option.nullable_to_opt(listRef.current), (function (listRef) {
                        var listener = Curry._1(arrowListener, listRef);
                        listRef.addEventListener("keydown", listener);
                        return function (param) {
                          listRef.removeEventListener("keydown", listener);
                        };
                      }));
        }), []);
  var onLotCardClick = React.useCallback(Curry.__1(selectLot), [selectLot]);
  var lastClosedSessionId = Belt_Option.map(Belt_Array.getBy(sessions, (function (x) {
              return x.state.state === "Closed";
            })), (function (x) {
          return x.sessionId;
        }));
  var isSessionOpened = Belt_Array.some(sessions, (function (x) {
          return x.state.state === "Open";
        }));
  return React.createElement("div", {
              className: Curry._1(Css.style, {
                    hd: Css.position("relative"),
                    tl: {
                      hd: Css.overflowY("auto"),
                      tl: {
                        hd: Css.display("flex"),
                        tl: {
                          hd: Css.flexDirection("column"),
                          tl: {
                            hd: Css.flex({
                                  NAME: "num",
                                  VAL: 1
                                }),
                            tl: /* [] */0
                          }
                        }
                      }
                    }
                  })
            }, React.createElement("ol", {
                  ref: Caml_option.some(listRef),
                  className: Curry._1(Css.style, {
                        hd: Css.overflowY("auto"),
                        tl: {
                          hd: Css.overflowX("hidden"),
                          tl: /* [] */0
                        }
                      })
                }, Belt_Array.map(sessions, (function (session) {
                        if (session.state.state === "Open" || sessions.length === 1 || Caml_obj.equal(lastClosedSessionId, session.sessionId) && !isSessionOpened) {
                          var sessionIdString = String(session.sessionId);
                          return Belt_Option.mapWithDefault(session.lotCards, null, (function (lotCards) {
                                        return JsxPPXReactSupport.createElementWithKey("session-lotcards-" + sessionIdString + "", LotCardList$LotCards, {
                                                    scrollView: scrollView,
                                                    lotCards: lotCards,
                                                    showLotCreators: useCreatorSplit,
                                                    selectedLotId: selectedLotId,
                                                    onClick: onLotCardClick,
                                                    me: me,
                                                    toggleMobileLotListClick: toggleMobileLotListClick
                                                  });
                                      }));
                        }
                        if (session.state.state === "Closed") {
                          return null;
                        }
                        var auctionUrl = Utils_Auction$LiveRoom.getAuctionUrl(fragment.slug.name, fragment.slug.year, session.sessionId, undefined);
                        return JsxPPXReactSupport.createElementWithKey("session-lotcards-" + String(session.sessionId) + "", LotCardList$NextSessionCard, {
                                    sessionTitle: session.title,
                                    sessionNumber: session.sessionId + 1 | 0,
                                    lotRange: session.lotRange,
                                    scheduledOpeningDate: session.scheduledOpeningDate,
                                    auctionUrl: auctionUrl
                                  });
                      }))), React.createElement("div", {
                  "aria-hidden": true,
                  className: Curry._1(Css.style, {
                        hd: StyleConstants$LiveRoom.defaultBorder("right", undefined, undefined),
                        tl: {
                          hd: Css.flex({
                                NAME: "num",
                                VAL: 1
                              }),
                          tl: /* [] */0
                        }
                      })
                }));
}

var PremiumLotStateFragment = ClientapiQueries$LiveRoom.LotCard.PremiumLotStateFragment;

var LatestUserBid = ClientapiQueries$LiveRoom.LotCard.LatestUserBid;

var BidStateFragment = ClientapiQueries$LiveRoom.LotCard.BidStateFragment;

var LotWithdrawnStateFragment = ClientapiQueries$LiveRoom.LotCard.LotWithdrawnStateFragment;

var LotCardFragment = ClientapiQueries$LiveRoom.LotCard.LotCardFragment;

var LotCardListAuctionFragment = ClientapiQueries$LiveRoom.LotCard.LotCardListAuctionFragment;

var virtualLazyLoadEnabled = true;

var virtualLazyLoadHorizon = 350;

var make = LotCardList;

export {
  PremiumLotStateFragment ,
  LatestUserBid ,
  BidStateFragment ,
  LotWithdrawnStateFragment ,
  LotCardFragment ,
  LotCardListAuctionFragment ,
  virtualLazyLoadEnabled ,
  virtualLazyLoadHorizon ,
  ParcelHeader ,
  LotCards ,
  NextSessionCard ,
  make ,
}
/* Css Not a pure module */
